module.exports = __webpack_public_path__ + "img/i_homework-close.1969893a.svg";